import React, { Suspense, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

import "react-pagination-js/dist/styles.css";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";

import { createBrowserHistory } from "history";
export const history = createBrowserHistory();
import Home from "./pages/Home/Home.jsx";
import BrowserProducts from "./pages/Products/BrowserProducts.jsx";
import ProductDetail from "./pages/Products/ProductDetail.jsx";
import ContactUs from "./pages/ContactUs/ContactUs.jsx";
import AboutUS from "./pages/AboutUs/Aboutus.jsx";
import PaymentConfirmed from "./pages/ThankyouPage.jsx";
import Login from "./methods/auth/login.jsx";
import Cart from "./pages/Cart/Cart.jsx";
import Signup from "./methods/auth/signup.jsx";
import Forgot from "./methods/auth/forgot.jsx";
import Reset from "./methods/auth/reset.jsx";
import PaymentFailed from "./pages/OrderStatus/PaymentFailed.jsx";
import OrderConfirmed from "./pages/OrderStatus/OrderConfirmed.jsx";
import ChangePassword from "./pages/Profile/ChangePassword.jsx";
import Profile from "./pages/Profile/Profile.jsx";
import EditProfile from "./pages/Profile/EditProfile.jsx";
import Dashboard from "./pages/dashboard";
import Orders from "./pages/Orders";
import ActionStatus from "./pages/AcceptReject/index.js";
import GuestOrderTracking from "./pages/TrackOrder/index.js";
import Hometwo from "./pages/Home/Hometwo.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy.jsx";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions.jsx";
import EstimateStatus from "./pages/EstimateStatus/index.js";
import OrderTrackingDetail from "./pages/OrderTracking/OrderTrackingDetail.jsx";
import CreateNewPassword from "./pages/Profile/CreateNewPassword.jsx";
import QuickBookEstimateDetailCustomer from "./pages/QuickBooks/QuickBookEstimateDetailCustomer.jsx";
import QuickBookInvoiceDetailCustomer from "./pages/QuickBooks/QuickBookInvoiceDetailCustomer.jsx";
import RouteTitle from "./RouteTitle";
import NoPages from "./pages/404/index.js";
import TenantDashboard from "./pages/TenantAdmin/TenantDashboard.jsx";
import TenantPlans from "./pages/TenantAdmin/TenantPlans.jsx";
import TenantNavPreview from "./pages/TenantAdmin/TenantNavPreview.jsx";
import TeamList from "./pages/TenantAdmin/Team/TeamList.jsx";
import TeamAddEdit from "./pages/TenantAdmin/Team/TeamAddEdit.jsx";
import TeamDetail from "./pages/TenantAdmin/Team/TeamDetail.jsx";
import TenantFloatingDock from "./pages/TenantAdmin/TenantFloatingDock.jsx";
import TenantEmailTemplatesList from "./pages/TenantAdmin/EmailTemplates/TenantEmailTemplatesList.jsx";
import ContactUsList from "./pages/TenantAdmin/ContactUs/ContactUsList.jsx";
import ContactUsDetail from "./pages/TenantAdmin/ContactUs/ContactUsDetail.jsx";
import { useDispatch } from "react-redux";
import { Logo } from "./actions/Logo";
import { getTenantInfo } from "./utils/domain";

export default () => {
  const dispatch = useDispatch();
  const tenantInfo = getTenantInfo();
  const hostname = window.location.hostname;
  const subDomain = "logistics.charlessmithassociates.com";
  // const subDomain = "localhost";

  useEffect(() => {
    dispatch(Logo());
  }, [dispatch]);

  return (
    <>
      <Suspense
        fallback={
          <div>
            <div id="loader" className="loaderDiv">
              <div>
                <img
                  src="/assets/img/loader.gif"
                  alt="logo"
                  className="pageLoader"
                  width="auto"
                  height="auto"
                />
              </div>
            </div>
          </div>
        }
      >
        <Router>
          <ScrollToTop />
          <RouteTitle />
          <TenantFloatingDock />
          <Routes>
            <Route
              path="/"
              element={
                tenantInfo.isTenantAdmin ? (
                  <TenantDashboard />
                ) : tenantInfo.isTenantFrontend ? (
                  <BrowserProducts />
                ) : tenantInfo.isTenant ? (
                  <BrowserProducts />
                ) : (
                  <Home />
                )
              }
            />
            <Route path="/products" element={<BrowserProducts />} />
            <Route path="/products/detail" element={<ProductDetail />} />
            <Route path="/contact/us" element={<ContactUs />} />
            <Route path="/about/us" element={<AboutUS />} />
            <Route path="/thankyou" element={<PaymentConfirmed />} />
            <Route path="/action" element={<ActionStatus />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/tenant/dashboard" element={<TenantDashboard />} />
            <Route path="/tenant-dashboard" element={<TenantDashboard />} />
            <Route path="/tenant/plans" element={<TenantPlans />} />
            <Route path="/tenant/subscription" element={<TenantPlans />} />
            <Route path="/tenant/customers" element={<TeamList />} />
            <Route path="/tenant/customers/add" element={<TeamAddEdit />} />
            <Route path="/tenant/customers/invite" element={<TeamAddEdit />} />
            <Route path="/tenant/customers/edit/:id" element={<TeamAddEdit />} />
            <Route path="/tenant/customers/detail/:id" element={<TeamDetail />} />
            <Route path="/tenant/inquiries" element={<ContactUsList />} />
            <Route path="/tenant/inquiries/detail/:id" element={<ContactUsDetail />} />
            <Route path="/tenant/contact-us" element={<ContactUsList />} />
            <Route path="/tenant/contact-us/detail/:id" element={<ContactUsDetail />} />
            <Route path="/tenant/email-templates" element={<TenantEmailTemplatesList />} />
            <Route path="/tenant/team" element={<TeamList />} />
            <Route path="/tenant/team/add" element={<TeamAddEdit />} />
            <Route path="/tenant/team/invite" element={<TeamAddEdit />} />
            <Route path="/tenant/team/edit/:id" element={<TeamAddEdit />} />
            <Route path="/tenant/team/detail/:id" element={<TeamDetail />} />
            <Route path="/orders" element={<Orders />} />

            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgotpassword" element={<Forgot />} />
            <Route path="/reset-password" element={<Reset />} />
            <Route path="/changepassword" element={<ChangePassword />} />
            <Route path="/create-password" element={<CreateNewPassword />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/payment/failed" element={<PaymentFailed />} />
            <Route path="/order/confirmed" element={<OrderConfirmed />} />
            <Route path="/estimate/status" element={<EstimateStatus />} />
            <Route
              path="/order/tracking/detail/:id"
              element={<OrderTrackingDetail />}
            />
            <Route
              path="/estimate/detail/:id"
              element={<QuickBookEstimateDetailCustomer />}
            />
            <Route
              path="/invoice/detail/:id"
              element={<QuickBookInvoiceDetailCustomer />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/editprofile" element={<EditProfile />} />
            <Route path="/track/orders" element={<GuestOrderTracking />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="*" element={<NoPages />} />
          </Routes>
        </Router>
      </Suspense>
      <div id="loader" className="loaderDiv !hidden">
        <div>
          <img
            src="/assets/img/loader.gif"
            width="auto"
            height="auto"
            alt="logo"
            className="pageLoader"
          />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
